module.exports = __webpack_public_path__ + "static/media/tambola-back.a2ff6078.svg";